function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M64.156 1H16.79C8.07 1 1 8.07 1 16.79v47.366c0 8.72 7.07 15.79 15.79 15.79h47.366c8.72 0 15.79-7.07 15.79-15.79V16.79c0-8.72-7.07-15.79-15.79-15.79z",
  fill: "#F6E6FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.508 57.5h-6.133a6.883 6.883 0 01-6.875-6.875V27.25a6.883 6.883 0 016.875-6.875h16.5a6.883 6.883 0 016.875 6.875v11.275a1.375 1.375 0 11-2.75 0V27.25a4.13 4.13 0 00-4.125-4.125h-16.5a4.13 4.13 0 00-4.125 4.125v23.375a4.13 4.13 0 004.125 4.125h6.133a1.375 1.375 0 110 2.75z",
  fill: "#8B1CCB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.625 61.625C44.319 61.625 40 57.307 40 52s4.319-9.625 9.625-9.625S59.25 46.693 59.25 52s-4.319 9.625-9.625 9.625zm0-16.5A6.883 6.883 0 0042.75 52a6.883 6.883 0 006.875 6.875A6.883 6.883 0 0056.5 52a6.883 6.883 0 00-6.875-6.875z",
  fill: "#8B1CCB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.708 55.483c-.352 0-.704-.135-.972-.403l-1.833-1.833a1.373 1.373 0 010-1.944 1.374 1.374 0 011.944 0l.861.86 2.695-2.693a1.374 1.374 0 011.944 0 1.374 1.374 0 010 1.944l-3.667 3.667a1.37 1.37 0 01-.972.402z",
  fill: "#8B1CCB"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 29.773,
  y: 35.548,
  width: 2.32,
  height: 4.297,
  rx: 1.083,
  fill: "#8B1CCB"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 33.609,
  y: 32.712,
  width: 2.32,
  height: 9.969,
  rx: 1.083,
  fill: "#8B1CCB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 37.445,
  y: 29.876,
  width: 2.32,
  height: 15.641,
  rx: 1.083,
  fill: "#8B1CCB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 41.281,
  y: 32.712,
  width: 2.32,
  height: 9.969,
  rx: 1.083,
  fill: "#8B1CCB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 45.117,
  y: 35.548,
  width: 2.32,
  height: 4.297,
  rx: 1.083,
  fill: "#8B1CCB"
});

var SvgReportListener = function SvgReportListener(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default SvgReportListener;